import { Component, Input } from '@angular/core';
import { Variable } from '../../model/variable/variable';
import { VariableValue } from '../../model/variable/variable-value';
import { ComponentVariable } from '../component-variable';


const HTML_TEMPLATE = `
<ion-item no-lines>
    <ion-label class="var-label-one-line">{{variable.description}}</ion-label>
    <ion-checkbox color="#0c9abe" [(ngModel)]="variableValue.value" (ionChange)="onChangeCallback()"></ion-checkbox>
</ion-item>
`;

const CSS_STYLE = `

`;

@Component({
    selector: 'variable-checkbox',
    template: HTML_TEMPLATE,
    styles: [CSS_STYLE]
})
export class VariableCheckboxComponent extends ComponentVariable {

    @Input('variable') variable: Variable;
    @Input('callbackOnChange') callback: Function;
    variableValue: VariableValue;

    constructor() {
        super();

        this.variableValue = {
            asBoolean: false,
            asString: "false",
            value: false
        }
    }

    ngOnInit() {
        this.setValue(this.variable.defaultValue);
        this.onChangeCallback();
    }

    getValue() {
        return this.variableValue;
    }

    setValue(variableValue: VariableValue): void {
        if (variableValue) {
            this.variableValue = {
                asBoolean: variableValue.value,
                asString: String(variableValue.value),
                value: variableValue.value
            }
        }
    }

    getVariable(): Variable {
        return this.variable;
    }

    onChangeCallback(): void {
        this.setValue(this.variableValue);

        this.callback(this);
    }

}
